import { AvailableLocale } from '@omnea-digital/toolbox'
import { enUS, fr, enGB, es, de, it as itIt, nl, ja, pt } from 'date-fns/locale'
import { assertNever } from 'utils/type-guard/assertNever'

/**
 * Returns the date-fns locale object for the given locale, in case it's needed to use date-fns functions directly.
 * It should be used with caution, as it's highly recommended to use the `formatDate` function from `@omnea/toolbox` (via the `useFormatter` hook).
 * Only use this function for specific and one-off date formatting which is not supported by the toolbox's `formatDate` function.
 */
// TODO: export this function from toolbox (where it already exists)
export const getDateFnsLocaleObject = (locale: AvailableLocale) => {
  switch (locale) {
    case 'en-US':
      return enUS
    case 'en-GB':
      return enGB
    case 'fr-FR':
      return fr
    case 'es-ES':
      return es
    case 'it-IT':
      return itIt
    case 'de-DE':
      return de
    case 'ja-JP':
      return ja
    case 'nl-NL':
      return nl
    case 'pt-PT':
      return pt
    default:
      assertNever(locale)
      return enGB
  }
}
